import { analyzeAndValidateNgModules } from '@angular/compiler';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { List } from 'immutable';
import { forkJoin } from 'rxjs';
import { BaseDataService, BaseInlineContainer, BaseUpdateComponent, CommonService, ModalService, NotificationService, QueryParameter, UserRightsService } from 'yt-ng-framework';
import { OrgJedDefgini } from './orgjeddefgini';
import { OrgJedDefginiView } from './orgjeddefgini-view';
import { UserIPAddress } from './useripadress/useripaddress';
// import { ToastrService } from 'ngx-toastr';



@Component({
  selector: 'yt-orgjeddefgini-update',
  templateUrl: './orgjeddefgini-update.component.html'
})
export class OrgjeddefginiUpdateComponent extends BaseUpdateComponent<OrgJedDefgini> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected commonService: CommonService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected userRightsService: UserRightsService,
    protected modalService: ModalService
    
  ) {
    super(activatedRoute, baseDataService, toastrService,translateService,modalService);
  }

   result: Array<OrgJedDefginiView> = [];
   formGroup = new FormGroup({});
   formGroupProvajder = new FormGroup({ID: new FormControl('')});
   formGroupIpAdress = new FormGroup({ID: new FormControl('')});
   parameterList: List<QueryParameter> = List([]);
   userProvajder: QueryParameter = new QueryParameter();
   showDropdown: boolean = false;
   response: any;
   hasUserRights: boolean;
   hasUserRightsIpAdress: boolean;



  ngOnInit() {
    
    this.hasUserRights = this.userRightsService.GetUserRightValue(this.modelData.MainList.UserRightsModelName,"see_KeysTab")
    this.hasUserRightsIpAdress = this.userRightsService.GetUserRightValue(this.modelData.MainList.UserRightsModelName,"see_IpTab")

    this.IDProcessed
    .subscribe((value) => {
      if(value){
        this.LoadDefgini();
        this.LoadUsersByOrgJed(value);
      }
    })    
  }

  LoadDefgini(){
    let __this = this;
    
    let parameters = this.Item.ID; 
      
    this.baseDataService.GetData('defgini', 'getByOrgJed', parameters)
    .subscribe(data => {
     this.response = data;
     this.result = [];
      this.response.forEach(res => {
        var Defgini: OrgJedDefginiView=new OrgJedDefginiView();
        Defgini.Naziv = res.Naziv;
        Defgini.Vrednost = res.Vrednost;
        Defgini.Tip = res.Tip;
        Defgini.Opis = res.Opis;
        __this.result.push(Defgini);
      })

      if((Object.keys(this.formGroup.controls).length)>0){
        this.UpdateValue();
      }else{
        this.CreateControls();
      }

      this.changeDetectorRef.markForCheck();

    })
  }

  CreateControls(){

    if(this.formGroup.contains(this.result[0].Naziv)){
      return;
    }
    this.result.forEach(item => {
      this.formGroup.addControl(item.Naziv, new FormControl(this.UrediVrednosti(item.Tip, item.Vrednost)));
    }) 
  }

  UpdateValue(){
    this.result.forEach(item => {
      // this.formGroup.patchValue({Naziv: item.Naziv, Vrednost: item.Vrednost});
      // var vr = this.formGroup.get('g_jezik');
      this.formGroup.get(item.Naziv).patchValue(this.UrediVrednosti(item.Tip,item.Vrednost));
    })
  }

  UrediVrednosti(tip, vrednost: string){
    if(tip == "nvarchar")
      return vrednost = vrednost;
    if(tip == "int")
      return vrednost = vrednost;
    if((tip == "bit") && (vrednost.toLowerCase() == "true")){
      vrednost = 'true';
      return Boolean(vrednost);
    }
    if((tip == "bit") && (vrednost.toLowerCase() == "false")){
      vrednost = '';
      return Boolean(vrednost);
    }
  }

  onVrednostChange(vrednost, naziv){
    let parameters = { OrgJedId: this.Item.ID, DefginiNaziv: naziv, Vrednost: vrednost};
    this.baseDataService.Post('defgIni', 'Save', parameters, null)
      .subscribe(()=>{
        // this.notificationsService.success('Uspešno', 'Sačuvan');
        this.toastrService.success('Uspešno', 'Sačuvan');
      });
  }

  LoadUsersByOrgJed(value){
    let parameter = new QueryParameter('OrgJedId' , value);
    return this.baseDataService.Get('UserLight', 'getByOrgJedId', [parameter],null)
  }

}
